export default {
      id: "Icon--directionUp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--directionUp",
      toString: function () {
        return this.url;
      }
    }